import { render, staticRenderFns } from "./inspectionPlanList.vue?vue&type=template&id=72aff8a4&scoped=true"
import script from "./inspectionPlanList.vue?vue&type=script&lang=js"
export * from "./inspectionPlanList.vue?vue&type=script&lang=js"
import style0 from "./inspectionPlanList.vue?vue&type=style&index=0&id=72aff8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aff8a4",
  null
  
)

export default component.exports